<template >
  <div class="component-container">
    <app-navigation></app-navigation>
    <div class="main-div" :class="formState.invalidShake?'invalid':''">
      <small
        class="--centered-block"
        v-if="(newQuestion==null)"
      >Select a Question From the list to edit. Press the Add New Button to add a new Question</small>
      <div class="form-group col-12 col-sm-12" v-if="newQuestion==null">
        <label class="pl-0 col-12 col-sm-12">All Questions</label>
        <div class="p-0 mb-4 col-12 col-sm-12">
          <input
            class="form-control"
            type="text"
            maxlength="200"
            placeholder="Search All questions"
            v-model="questionsSearch"
          />
        </div>
        <b-form-select
          :disabled="formState.loading"
          class="col-12 col-sm-12"
          style="font-size:16px;"
          v-model="selectedQuestionId"
          :options="filteredQuestions"
          :select-size="+10"
        ></b-form-select>
      </div>

      <div
        v-if="errors.length && formState.attempted && (!formState.loading)"
        class="col-12 col-sm-12"
      >
        <b class="w-100">Please correct the following error(s):</b>
        <ul>
          <li v-for="(error,index) in errors" :key="index">{{ error }}</li>
        </ul>
      </div>

      <form class="question-form">
        <fieldset
          :disabled="formState.loading"
          class="p-0 col-12 col-sm-12"
          v-if="(newQuestion==null)&&selectedQuestionData"
        >
          <legend>Existing Question's Data</legend>
          <div class="row">
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4">Question</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="text"
                maxlength="200"
                v-model="selectedQuestionData.question"
                placeholder="السؤال بالعربيه"
              />
            </div>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4">Question (EN)</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="text"
                maxlength="200"
                v-model="selectedQuestionData.question_en"
                placeholder="Question in English"
              />
            </div>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4">Answer</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="text"
                maxlength="1000"
                v-model="selectedQuestionData.answer"
                placeholder="الإجابة بالعربيه"
              />
            </div>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4">Answer (EN)</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="text"
                maxlength="1000"
                v-model="selectedQuestionData.answer_en"
                placeholder="Answer in English"
              />
            </div>
          </div>
        </fieldset>
        <div class="form-group col-12 col-sm-12">
          <div class="form-group col-12 col-sm-6" v-if="(newQuestion==null)&&selectedQuestionData">
            <button
              type="button"
              v-on:click="deleteQuestion()"
              class="btn btn-danger"
              :disabled="formState.loading"
            >Delete Selected question</button>
          </div>
          <div class="form-group col-12 col-sm-6" v-if="(newQuestion==null)&&selectedQuestionData">
            <button
              :disabled="formState.loading"
              type="button"
              v-on:click="commitChanges()"
              class="btn btn-info"
            >Confirm Changes</button>
          </div>
        </div>

        <fieldset
          :disabled="formState.loading"
          class="p-0 col-12 col-sm-12"
          v-if="(newQuestion!=null)"
        >
          <legend>New Question's Data</legend>
          <div class="row">
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4">Question</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="text"
                maxlength="201"
                v-model="newQuestion.question"
                placeholder="السؤال بالعربيه"
              />
            </div>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4">Question (EN)</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="text"
                maxlength="201"
                v-model="newQuestion.question_en"
                placeholder="Question in English"
              />
            </div>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4">Answer</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="text"
                maxlength="1001"
                v-model="newQuestion.answer"
                placeholder="الإجابة بالعربيه"
              />
            </div>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4">Answer (EN)</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="text"
                maxlength="1001"
                v-model="newQuestion.answer_en"
                placeholder="Answer in English"
              />
            </div>
          </div>
        </fieldset>

        <div class="col-12 col-sm-12" v-if="newQuestion!=null">
          <button
            :disabled="formState.loading"
            type="button"
            v-on:click="saveNewQuestion()"
            class="btn btn-info"
          >Save New Question</button>
          <button
            :disabled="formState.loading"
            type="button"
            v-on:click="cancelNewQuestion()"
            class="btn btn-danger"
          >Cancel New Question</button>
        </div>

        <div class="col-12 col-sm-12" v-if="newQuestion==null">
          <button
            :disabled="formState.loading"
            type="button"
            v-on:click="addNewQuestion()"
            class="m-0 btn btn-success"
          >Add New Question</button>
        </div>
      </form>
    </div>
  </div>
</template>



<!-- question Template -->




<style lang='scss' scoped>
@import "../../node_modules/bootstrap/scss/bootstrap.scss";
.modified-dropdown {
  -webkit-appearance: menulist;
  background: none;
}
.component-container {
  min-height: 100%;
  display: flex;
}

.main-div {
  padding: 50px;
  width: 80%;
  div {
    display: flex;
    flex-wrap: wrap;
    text-align: left;
    justify-content: space-between;
  }

  button {
    margin: 0 auto;
    padding: 10px 30px;
    font-size: 16px;
  }

  .--centered-block {
    margin: 0 auto;
  }
}

//  0.82s
.invalid {
  animation: shake 0.82s infinite cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}
</style>

<script>
import axios from "axios";
/* eslint-disable no-unused-vars */
import VueAxios from "vue-axios";
import { constants } from "crypto";
import { setTimeout } from "timers";
/* eslint-enable no-unused-vars*/
import { getCookie } from "../cookie.js";
import { herokuUrl } from "../apiConfig";
import Navigation from "../components/Navigation.vue";
import logOut from "../scripts/utils";

export default {
  question: "questionsCRUD",
  data() {
    return {
      newQuestion: null, // If add question button is pressed, this will be an object with a question, a answer and a question_en.
      questionsSearch: "", // We search All questions Depending on this.
      selectedQuestionId: null, // Specifies The Id of the selected question in the database
      selectedQuestionData: null, // Data is fetched from the backend using selectedQuestionId
      questions: [{ value: null, text: "Please select a question to edit" }], // All questions (Fetched When component is mounted)
      filteredQuestions: [
        { value: null, text: "Please select a question to edit" }
      ], // All questions Filtered Using questionsSearch
      errors: [], // Form's errors
      formState: {
        loading: false,
        attempted: false,
        invalidShake: false
      } // Object Determining the Form's state
    };
  },
  watch: {
    // Computes the Filtered Array out of questions fetched from backend.
    questionsSearch: function() {
      this.filteredQuestions = this.questions.filter(str => {
        return this.questionsSearch == ""
          ? true
          : str.text.toLowerCase().includes(this.questionsSearch.toLowerCase());
      });
      if (this.filteredQuestions.length < 1)
        this.filteredQuestions = [{ value: null, text: "No such result" }];
    },
    // When selectedQuestionId is changed, the question's Data is fetched from the backend, If null is selected, the form is reset.
    selectedQuestionId: function() {
      if (this.selectedQuestionId) {
        for (let i = 1; i < this.questions.length; i++) {
          let element = this.questions[i].data;
          if (element.id == this.selectedQuestionId) {
            this.selectedQuestionData = element;
            break;
          }
        }
      } else {
        this.partiallyResetForm();
      }
    },
    newQuestion: function() {
      this.checkForm();
    },
    selectedQuestionData: function() {
      this.checkForm();
    }
  },
  mounted() {
    this.fetchAllquestions();
  },
  methods: {
    // Partially resets the form
    partiallyResetForm: function() {
      this.cancelNewQuestion();
      this.selectedQuestionData = null;
      this.selectedQuestionId = null;
      this.errors = [];
      this.formState = {
        loading: false,
        attempted: false,
        invalidShake: false
      };
    },
    checkForm: function() {
      this.errors = [];
      if (this.newQuestion) {
        if (
          String(this.newQuestion.question).length < 5 ||
          String(this.newQuestion.question).length > 200
        )
          this.errors.push(
            "Question is required, length should be between 5 and 200 charachters"
          );
        if (
          String(this.newQuestion.question_en).length < 5 ||
          String(this.newQuestion.question_en).length > 200
        )
          this.errors.push(
            "Question in English is required, length should be between 5 and 200 charachters"
          );
        if (
          String(this.newQuestion.answer).length < 5 ||
          String(this.newQuestion.answer).length > 1000
        )
          this.errors.push(
            "Answer is required, length should be between 5 and 1000 charachters"
          );
        if (
          String(this.newQuestion.answer_en).length < 5 ||
          String(this.newQuestion.answer_en).length > 1000
        )
          this.errors.push(
            "Answer in English is required, length should be between 5 and 1000 charachters"
          );
      } else if (this.selectedQuestionData) {
        if (
          String(this.selectedQuestionData.question).length < 5 ||
          String(this.selectedQuestionData.question).length > 200
        )
          this.errors.push(
            "Question is required, length should be between 5 and 200 charachters"
          );
        if (
          String(this.selectedQuestionData.question_en).length < 5 ||
          String(this.selectedQuestionData.question_en).length > 200
        )
          this.errors.push(
            "Question in English is required, length should be between 5 and 200 charachters"
          );
        if (
          String(this.selectedQuestionData.answer).length < 5 ||
          String(this.selectedQuestionData.answer).length > 1000
        )
          this.errors.push(
            "Answer is required, length should be between 5 and 1000 charachters"
          );
        if (
          String(this.selectedQuestionData.answer_en).length < 5 ||
          String(this.selectedQuestionData.answer_en).length > 1000
        )
          this.errors.push(
            "Answer in English is required, length should be between 5 and 1000 charachters"
          );
      }
    },
    fetchAllquestions() {
      this.formState.loading = true;
      return axios
        .post(`${herokuUrl}/dashboard/getAllquestions`, null, {
          headers: {
            Authorization: getCookie("user")
          }
        })
        .then(res => {
          this.questions = [
            { value: null, text: "Please select a question to edit" }
          ];
          res.data.questions.forEach(element => {
            this.questions.push({
              text: element.question,
              value: element.id,
              data: element
            });
          });
          this.filteredQuestions = [...this.questions];
          this.formState.loading = false;
        })
        .catch(err => {
          if(err.response.status == 401) {
            logOut();
          } else {
            this.formState.loading = false;
            alert(
              "Questions fetching failed, " +
                err.response.data.message
            );
          }
          // window.location.reload();
        });
    },
    deleteQuestion() {
      if (confirm("Please confirm you want to DELETE the selected question")) {
        this.formState.loading = true;
        return axios
          .post(
            `${herokuUrl}/dashboard/deleteQuestion`,
            {
              id: this.selectedQuestionData.id
            },
            {
              headers: {
                Authorization: getCookie("user")
              }
            }
          )
          .then(() => {
            alert("question was deleted successfully");
            this.partiallyResetForm();
            this.fetchAllquestions();
          })
          .catch(err => {
            if(err.response.status == 401) {
              logOut();
            } else {
              this.formState.loading = false;
              alert(
                "There was a problem deleting the selected question " +
                  err.response.data.message
              );
            }
          });
      }
    },
    commitChanges() {
      this.formState.attempted = true;
      if (!this.errors.length) {
        if (
          confirm(
            "Please confirm you want to UPDATE the selected question with the new data"
          )
        ) {
          this.formState.loading = true;
          return axios
            .post(
              `${herokuUrl}/dashboard/editQuestion`,
              this.selectedQuestionData,
              {
                headers: {
                  Authorization: getCookie("user")
                }
              }
            )
            .then(() => {
              alert("question was Edited successfully");
              this.partiallyResetForm();
              this.fetchAllquestions();
            })
            .catch(err => {
              if(err.response.status == 401) {
                logOut();
              } else {
                this.formState.loading = false;
                alert(
                  "There was a problem editing the selected question " +
                    err.response.data.message
                );
              }
            });
        }
      } else {
        this.shakeForm();
      }
    },
    shakeForm() {
      this.formState.invalidShake = true;
      setTimeout(
        function() {
          this.formState.invalidShake = false;
        }.bind(this),
        820
      );
    },
    addNewQuestion() {
      this.newQuestion = {
        question: "",
        question_en: "",
        answer: "",
        answer_en: ""
      };
    },
    cancelNewQuestion() {
      this.newQuestion = null;
    },
    saveNewQuestion() {
      this.formState.attempted = true;
      if (!this.errors.length) {
        if (confirm("Please confirm you want to Add a new question")) {
          this.formState.loading = true;
          return axios
            .post(
              `${herokuUrl}/dashboard/addNewQuestion`,
              { ...this.newQuestion },
              {
                headers: {
                  Authorization: getCookie("user")
                }
              }
            )
            .then(() => {
              alert("question was Added successfully");
              this.partiallyResetForm();
              this.fetchAllquestions();
            })
            .catch(err => {
              if(err.response.status == 401) {
                logOut();
              } else {
                this.formState.loading = false;
                alert(
                  "There was a problem adding the new question " +
                    err.response.data.message
                );
              }
            });
        }
      } else {
        this.shakeForm();
      }
    }
  },
  components: {
    appNavigation: Navigation
  }
};
</script>
